{
  "main": {
    "title": "Panoramica del registro",
    "nazaj": "Indietro"
  },
  "navs": {
    "brisanje": "Cancellazioni",
    "urejanje": "Modifiche"
  },
  "table": {
    "titleJ": "VOLI ALIANTE",
    "titleM": "VOLI A MOTORE"
  },
  "modal": {
    "izbrisal": "Record eliminato da:",
    "reg": "registrazione:",
    "vlecno": "aereo da traino:",
    "pilot": "pilota:",
    "instruktor": "istruttore:",
    "namen": "scopo:",
    "naloga": "compito:",
    "krajV": "luogo di decollo:",
    "krajP": "luogo di atterraggio:",
    "casV": "ora del decollo:",
    "casP": "ora dell’atterraggio:",
    "casL": "tempo di volo:",
    "stPristankov": "numero di atterraggi:",
    "ifr": "ifr:",
    "nocno": "notturno:",
    "vizuelno": "visivo:",
    "opomba": "nota:",
    "datumL": "data del volo:",
    "datumV": "data di inserimento:",
    "datumB": "data della cancellazione:",
    "regV": "reg. del traino:",
    "casO": "ora di sgancio:",
    "casVL": "tempo di traino:"
  }
}